import React from "react";
import {
    LandingPageBg,
    LandingPageContainer,
    LandingPageContent,
    LandingPageImage, 
    LandingPageText, 
    LandingPageTitle, 
    LandingPageBottomText,
    LandingPageSecondContainer,
    LandingPageSecondContent,
    LandingPageSubText,
    LandingPageOverlay,
    LandingPageButtonRow,
    LandingPageLogoImage,
    LandingPageSimpleContainer,
    RecommendationsImage,
    RecommendationsContainer,
    LandingPageSimpleButtonsContainer
} from "./LandingPageElements";
import {
    DesktopOnly,
    MobileOnly,
    MobileContainer,
    MobileTitle,
    MobileVideo,
    DesktopInlineOnly,
} from "../CommonElements";
import secondImage from '../../images/landing_page_second_image.jpg';
import logoImage from '../../images/ps_white_logo.png';
import modernTxtImage from '../../images/modern_txt.png';
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import './LandingPage.css';
import { LandingPageTilesContainer, LandingPageTileImage, LandingPageTile } from "./LandingPageTilesElements";
import promotionalImage from "../../images/promotionalImage.png";
import eventImage from "../../images/eventImage.png";
import socialMediaImage from "../../images/socialMediaImage.png";
import weddingImage from "../../images/weddingsImage.png";
import recommendationsImage from "../../images/recommendations.jpg";


const LandingPage = () => {
    const navigate = useNavigate();

    return (
        <>
            <DesktopOnly>
            <LandingPageContainer>
                <LandingPageBg>
                    <video autoPlay loop muted playsInline className="App-logo">
                    <source src="/videos/background_Desktop_main.mp4" type="video/mp4" />
                    </video>
                    <LandingPageOverlay />
                </LandingPageBg>

                <LandingPageContent>
                    <LandingPageTitle>
                    You deserve a story that captivates
                    <br />
                    <br />
                    <br />
                    We bring it to life
                    <br />
                    </LandingPageTitle>
                </LandingPageContent>

                <LandingPageBottomText>
                    Promotional | Events | Social Media | Weddings
                </LandingPageBottomText>
            </LandingPageContainer>
            </DesktopOnly>

            <MobileOnly>
                <MobileContainer>
                    <MobileTitle>
                    You deserve a story that captivates<br />
                    We bring it to life
                    </MobileTitle>
                    <MobileVideo
                    autoPlay
                    muted
                    playsInline
                    loop
                    src="/videos/background_Desktop_main.mp4"
                    />
                </MobileContainer>
            </MobileOnly>

            <LandingPageSecondContent>
                <LandingPageSubText>
                    <span style={{ fontSize: "24px", fontWeight: '1000' }}>Stories that move people, not just pictures</span>
                    <br />
                    We craft videos where every detail counts, turning ideas into powerful emotions.
                    <DesktopInlineOnly><br /></DesktopInlineOnly>
                    &nbsp;For those who refuse mediocrity, we deliver films that inspire, engage, and stay in memory.
                    <br />
                    <br />
                    <br />
                    <br />
                    <span style={{ fontSize: "24px", fontWeight: '1000' }}>Video that works harder than words</span>
                    <br />
                    Our productions aren’t random clips but strategic stories designed to connect with your audience.
                    <DesktopInlineOnly><br /></DesktopInlineOnly>&nbsp;We help brands stand out with visuals backed by creativity and precision.
                    <br />
                    <br />
                    <br />
                </LandingPageSubText>
                <Button className="rounded-button" onClick={() => navigate("/contact")}>
                    👉 Get a Quote For Your Idea
                </Button>
                <LandingPageText>
                    <br />
                    <br />
                    <br />
                    OR
                    <br />
                    <br />
                    <br />
                    Select a Package and
                    <br />
                    ⚡ Get Started INSTANTLY ⚡
                    <br />
                    <br />
                </LandingPageText>
            </LandingPageSecondContent>
            
            <LandingPageTilesContainer>
            <LandingPageTile>
                <LandingPageTileImage src={promotionalImage} alt="Promotional" onClick={() => navigate("/services/promotional")}/>
            </LandingPageTile>
            <LandingPageTile>
                <LandingPageTileImage src={eventImage} alt="Event" onClick={() => navigate("/services/event")}/>
            </LandingPageTile>
            <LandingPageTile>
                <LandingPageTileImage src={socialMediaImage} alt="Social Media" onClick={() => navigate("/services/social-media")}/>
            </LandingPageTile>
            <LandingPageTile>
                <LandingPageTileImage src={weddingImage} alt="Wedding" onClick={() => navigate("/services/wedding")}/>
            </LandingPageTile>
            </LandingPageTilesContainer>
            <LandingPageSimpleContainer>
                    <LandingPageLogoImage
                    src={modernTxtImage}
                    alt="logo" />
                    <LandingPageLogoImage 
                    src={logoImage}
                    alt="logo"/>
            </LandingPageSimpleContainer>
            

            <LandingPageSimpleButtonsContainer>
                <LandingPageButtonRow>
                    <Button
                    className="rounded-button"
                    href="https://www.instagram.com/progress.studio.uk" 
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    >
                    📸 Instagram
                    </Button>

                    <Button
                    className="rounded-button"
                    onClick={() => navigate("/about")}
                    >
                    👉 About Us
                    </Button>

                    <Button
                    className="rounded-button"
                    href="https://www.facebook.com/progress.studio.uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    >
                    👍 Facebook
                    </Button>
                    </LandingPageButtonRow>
            </LandingPageSimpleButtonsContainer>

            <LandingPageSecondContainer>
                <LandingPageImage
                    src={secondImage}
                    alt="logo"
                />
            </LandingPageSecondContainer>
            <LandingPageSecondContent>
                <LandingPageText>
                    <br />
                    <br />
                    Reviews That Speak for Themselves
                    <br />
                    <span style={{ fontSize: "32px", fontWeight: '1000' }}>Real</span> Feedback from <span style={{ fontSize: "32px", fontWeight: '1000' }}>Real</span> Users
                    <br />
                    <br />
                    100% SATISFIED CUSTOMERS!
                    <br />
                    <br />
                    <br />
                </LandingPageText>
            </LandingPageSecondContent>
            <RecommendationsContainer>
                <RecommendationsImage
                    src={recommendationsImage}
                    alt="recommendationsImage"
                />
            </RecommendationsContainer>
        </>
    );
}

export default LandingPage;
